module.exports = __webpack_public_path__ + "media/images/wedding/24-2c1039b1eec88b778db0f19d65514dae.jpg";